import color from '@deprecated-ui/_style/color';
import Text from '@deprecated-ui/common/Text';
import { removeFormat } from 'features/chat/utils';
import Image from 'global/Image';
import {
  DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW,
  DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED,
} from './__tests__/constant';
import { DeletedLastMessage } from './styled';

interface AttachmentPreviewProps {
  type:
    | 'ATTACHMENT_TYPE_GIF'
    | 'ATTACHMENT_TYPE_PHOTO'
    | 'ATTACHMENT_TYPE_POST'
    | 'ATTACHMENT_TYPE_GIF'
    | 'ATTACHMENT_TYPE_PDF'
    | 'ATTACHMENT_TYPE_STICKER'
    | 'ATTACHMENT_TYPE_SHARETRADE'
    | 'ATTACHMENT_TYPE_UNSPECIFIED';
}

function AttachmentPreview({ type }: AttachmentPreviewProps) {
  if (type === 'ATTACHMENT_TYPE_GIF') {
    return <Image src="/icon/preview-gif.svg" alt="Gif icon" />;
  }
  if (type === 'ATTACHMENT_TYPE_PHOTO') {
    return <Image src="/icon/preview-photo.svg" alt="Photo icon" />;
  }
  if (type === 'ATTACHMENT_TYPE_POST') {
    return <Image src="/icon/preview-post.svg" alt="Post icon" />;
  }
  if (type === 'ATTACHMENT_TYPE_PDF') {
    return <Image src="/icon/preview-pdf.svg" alt="Post icon" />;
  }
  if (type === 'ATTACHMENT_TYPE_STICKER') {
    return <Image src="/icon/preview-sticker.svg" alt="Post icon" />;
  }
  return null;
}

export interface LastMessagePreviewProps {
  message: any;
  showSenderUsername: boolean;
}

function LastMessagePreview({
  message,
  showSenderUsername,
}: LastMessagePreviewProps) {
  const {
    type: attachmentType,
    sender_username: senderUsername = '',
    is_deleted: isDeleted,
  } = message;

  const parseLastMessage = () => {
    const isMessageEmpty = message?.text === '';
    if (attachmentType === 'ATTACHMENT_TYPE_STICKER') {
      return 'Sticker';
    }
    if (attachmentType === 'ATTACHMENT_TYPE_GIF') {
      return 'GIF';
    }
    if (attachmentType === 'ATTACHMENT_TYPE_PHOTO' && isMessageEmpty) {
      return 'Photo';
    }
    if (attachmentType === 'ATTACHMENT_TYPE_POST' && isMessageEmpty) {
      return 'Post';
    }

    return message?.text;
  };

  const showedMessage = parseLastMessage();
  const asteriskRemover = removeFormat(showedMessage);
  if (isDeleted) {
    return (
      <DeletedLastMessage
        ellipsis
        data-cy={DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED}
      >
        <Image src="/icon/chat-bubble-removed-gray.svg" />
        {asteriskRemover}
      </DeletedLastMessage>
    );
  }

  return (
    <Text
      width="90%"
      color={color.midgray}
      ellipsis
      data-cy={DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW}
    >
      {showSenderUsername && senderUsername ? `${senderUsername}: ` : null}
      <AttachmentPreview type={attachmentType} />

      {asteriskRemover}
    </Text>
  );
}

export default LastMessagePreview;
